// src/types/Dimensions.ts
export interface Dimensions {
    width: number;
    height: number;
}

export interface ScaledPosition {
    x: number;
    y: number;
    scale: number;
}

export function calculateScaledDimensions(
    containerWidth: number,
    containerHeight: number,
    imageWidth: number,
    imageHeight: number
): ScaledPosition {
    const containerRatio = containerWidth / containerHeight;
    const imageRatio = imageWidth / imageHeight;

    let scale: number;
    let x: number = 0;
    let y: number = 0;

    if (containerRatio > imageRatio) {
        // Container is wider than image - fit to width
        scale = containerWidth / imageWidth;
    } else {
        // Container is taller than image - fit to height
        scale = containerHeight / imageHeight;
    }

    // Center the scaled image
    x = (containerWidth - (imageWidth * scale)) / 2;
    y = (containerHeight - (imageHeight * scale)) / 2;

    return { x, y, scale };
}